import { CSSObject } from '@emotion/react';
import { theme } from '@frontend/theme';

export const floatingStyles: CSSObject = {
  alignItems: 'center',
  border: 0,
  borderRadius: theme.borderRadius.small,
  display: 'flex',
  fontSize: theme.font.size.medium,
  justifyContent: 'center',
  lineHeight: 1,
  minHeight: theme.spacing(4),
  minWidth: theme.spacing(4),
  padding: theme.spacing(0, 1),
  transition: 'all 250ms ease',
  whiteSpace: 'nowrap',
  '.floating-toolbar.right-top &, .floating-toolbar.right-center &, .floating-toolbar.right-bottom &': {
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
    marginLeft: '2px', // Compensate for section border width
  },
  '.floating-toolbar.left-top &, .floating-toolbar.left-center &, .floating-toolbar.left-bottom &': {
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0,
    marginRight: '2px', // Compensate for section border width
  },
};
